import { BaseShop, ShopsParams } from "@/store/dictionaries/shops";
import { formatDateToYYYYMMDD } from "../utils/DateParser";

export function areShopFieldsValid(shop: BaseShop): boolean {
    return !(!shop.shop_name || !shop.shop_inn || !shop.category_id);
}

export function setShopsParamsByFilter(params: ShopsParams, settings: TableSettings) {
    if (settings.orderField) {
        params.order_by = settings.orderField;
    } else {
        params.order_by = '-mtime';
    }

    if (settings.commonFilter) {
        params.shop_name__ilike = settings.commonFilter;
    }

    if (Object.keys(settings.filter).length > 0) {
        if (settings.filter.name) {
            params.shop_name__ilike = settings.filter.name;
        }

        if (settings.filter.short_name) {
            params.shop_short_name__ilike = settings.filter.short_name;
        }

        if (settings.filter.inn) {
            params.shop_inn = settings.filter.inn;
        }

        if (settings.filter.hash_inn) {
            params.shop_pk = settings.filter.hash_inn;
        }

        if (settings.filter.user.length > 0) {
            params.cuser__id__in = settings.filter.user.join(",");
        }

        if (settings.filter.category.length > 0) {
            params.categories__category_id__in = settings.filter.category.join(",");
        }

        if (settings.filter.cdate)
            params.cdate = formatDateToYYYYMMDD(settings.filter.cdate);

        if (settings.filter.mdate)
            params.mdate = formatDateToYYYYMMDD(settings.filter.mdate);

        if ((settings.filter.has_data_from_providers ?? "").length > 0) {
            params.has_data_from_providers =
                settings.filter.has_data_from_providers == "1";
        }
    }
}

interface TableSettings {
    first: number;
    orderField: string;
    commonFilter: string;
    filter: FilterForm;
}

export interface FilterForm {
    name: string;
    short_name: string;
    inn: string;
    hash_inn: string;
    cdate: Date | null;
    mdate: Date | null;
    user: number[];
    category: number[];
    has_data_from_providers: string;
}